import dayjs from 'dayjs';

import { getDifferenceInMinutes } from '../../../../../../helpers/datetime';

export const getWeekDate = (date: Date): string => {
  return dayjs(date).format('D MMM YYYY (dddd)');
};

export const getTimeBeforeEvent = (unixTimestamp: number): string => {
  const diffMs = getDifferenceInMinutes(unixTimestamp);

  if (diffMs <= 0) {
    return '';
  }

  const days = Math.floor(diffMs / (60 * 24));
  const hours = Math.floor((diffMs % (60 * 24)) / 60);
  const minutes = diffMs % 60;

  const parts: string[] = [];

  if (days) {
    parts.push(`${days}d`);
  }

  if (days > 3) {
    return parts.join(' ');
  }

  if (hours) {
    parts.push(`${hours}h`);
  }

  if (minutes) {
    parts.push(`${minutes}min`);
  }

  return parts.join(' ');
};
